var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.params.value)?_c('img',{staticStyle:{"height":"75px"},attrs:{"src":_vm.params.value + '?' + Date.now()}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }